<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2025-04-01 14:33:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-09 10:26:03
-->
<template>
  <div class="price-quotes">
    <!-- 背景装饰 -->
    <div class="bg-glow"></div>

    <div class="title">
      <img src="@/img/datav/title_icon.png" alt="" />
      <span>价格行情（白沙洲价）</span>
    </div>
    <div class="tip">单位：元/公斤 最新发布时间：{{ date }}</div>

    <div class="content">
      <div class="table-wrapper left">
        <div class="table-header">
          <div class="header-glow"></div>
        </div>
        <dv-scroll-board ref="scrollBoard1" :config="config1" class="scroll-board" />
        <div class="table-border left-border"></div>
      </div>

      <div class="table-wrapper right">
        <div class="table-header">
          <div class="header-glow"></div>
        </div>
        <dv-scroll-board ref="scrollBoard2" :config="config2" class="scroll-board" />
        <div class="table-border right-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
const options = {
  rowNum: 8,
  headerBGC: 'rgba(16, 30, 66, 0.95)',
  oddRowBGC: 'rgba(12, 24, 52, 0.6)',
  evenRowBGC: 'rgba(20, 36, 76, 0.8)',
  header: [
    '<span class="header-text">商品名称</span>',
    '<span class="header-text">产地/规格</span>',
    `<span class="header-text price-high">最高价</span><img src="${require('@/img/datav/up_icon.png')}" class="trend-icon up" alt="">`,
    `<span class="header-text price-low">最低价</span><img src="${require('@/img/datav/down_icon.png')}" class="trend-icon down" alt="">`,
    '<span class="header-text">均价</span>',
  ],
  columnWidth: [150, 160, 110, 110, 110],
  align: ['center', 'center', 'center', 'center', 'center'],
}

import { bszProductList } from '@/api/dashboard'
import to from 'await-to'

export default {
  name: 'PriceQuotes',
  data() {
    return {
      config1: {
        ...options,
        data: [],
      },
      config2: {
        ...options,
        data: [],
      },
      date: '',
    }
  },
  mounted() {
    this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  methods: {
    async initData() {
      const [res, err] = await to(bszProductList({}))
      if (err) return

      let data = res.data.map(item => [
        `<span class="cell-product">${item.productName}</span>`,
        `<span class="cell-origin">${item.originSpecification}</span>`,
        `<span class="cell-price high">${item.highestPrice}</span>`,
        `<span class="cell-price low">${item.lowestPrice}</span>`,
        `<span class="cell-price avg">${item.averagePrice}</span>`,
      ])

      this.config1 = { ...options, data: this.firstPart(data) }
      this.config2 = { ...options, data: this.secondPart(data) }
      this.date = res.extendData
    },
    firstPart(data) {
      const splitIndex = Math.ceil(data.length / 2)
      return data.slice(0, splitIndex)
    },
    secondPart(data) {
      const splitIndex = Math.ceil(data.length / 2)
      return data.slice(splitIndex)
    },
  },
}
</script>

<style lang="scss" scoped>
.price-quotes {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 30px 30px;
  overflow: hidden;

  // 背景发光效果
  .bg-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 60%;
    background: radial-gradient(
      ellipse at center,
      rgba(59, 130, 246, 0.08) 0%,
      rgba(30, 64, 175, 0.04) 40%,
      transparent 70%
    );
    pointer-events: none;
    animation: pulse-glow 4s ease-in-out infinite;
  }

  @keyframes pulse-glow {
    0%,
    100% {
      opacity: 0.6;
      transform: translate(-50%, -50%) scale(1);
    }
    50% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1.05);
    }
  }
}

// 标题区域 - 保持原样
.title {
  width: 550px;
  position: relative;
  font-size: 26px;
  color: #ecf8ff;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  img {
    margin-right: 3px;
  }
}

// 提示信息区域 - 保持原样
.tip {
  position: absolute;
  right: 35px;
  top: 30px;
  font-weight: 400;
  font-size: 23px;
  color: #ecf8ff;
}

// 内容区域
.content {
  display: flex;
  gap: 18px;
  position: relative;
  z-index: 1;
}

// 表格包装器
.table-wrapper {
  position: relative;
  flex: 1;
  height: 440px;
  overflow: hidden;

  .table-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 45px;
    z-index: 10;
    pointer-events: none;

    .header-glow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 2px;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(59, 130, 246, 0.8) 30%,
        rgba(245, 158, 11, 0.8) 70%,
        transparent 100%
      );
      animation: header-glow 3s ease-in-out infinite;
    }

    @keyframes header-glow {
      0%,
      100% {
        opacity: 0.6;
      }
      50% {
        opacity: 1;
      }
    }
  }

  .scroll-board {
    width: 100%;
    height: 100%;
  }

  .table-border {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 30px;
    pointer-events: none;

    &.left-border {
      background: linear-gradient(to top, rgba(59, 130, 246, 0.15) 0%, transparent 100%);
    }

    &.right-border {
      background: linear-gradient(to top, rgba(245, 158, 11, 0.15) 0%, transparent 100%);
    }
  }
}

// 深度选择器样式 - 表格样式优化
::v-deep .dv-scroll-board {
  .header {
    background: linear-gradient(
      180deg,
      rgba(16, 30, 66, 0.98) 0%,
      rgba(20, 40, 85, 0.95) 100%
    ) !important;
    border-bottom: 1px solid rgba(59, 130, 246, 0.3);

    .header-item {
      font-size: 20px;
      font-weight: 600;
      color: #ecf8ff;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      text-shadow: 0 0 10px rgba(236, 248, 255, 0.3);

      .header-text {
        &.price-high {
          color: #ff6b6b;
          text-shadow: 0 0 10px rgba(255, 107, 107, 0.4);
        }

        &.price-low {
          color: #12c76a;
          text-shadow: 0 0 10px rgba(18, 199, 106, 0.4);
        }
      }

      .trend-icon {
        width: 12px;
        height: 12px;
        animation: trend-bounce 2s ease-in-out infinite;

        &.up {
          filter: drop-shadow(0 0 4px rgba(255, 107, 107, 0.6));
        }

        &.down {
          filter: drop-shadow(0 0 4px rgba(18, 199, 106, 0.6));
          animation-delay: 0.5s;
        }
      }

      @keyframes trend-bounce {
        0%,
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-2px);
        }
      }
    }
  }

  .rows {
    .row-item {
      transition: all 0.3s ease;

      &:hover {
        background: linear-gradient(
          90deg,
          rgba(59, 130, 246, 0.15) 0%,
          rgba(59, 130, 246, 0.25) 50%,
          rgba(59, 130, 246, 0.15) 100%
        ) !important;
        transform: scale(1.01);
        box-shadow: 0 0 20px rgba(59, 130, 246, 0.2);
      }

      .ceil {
        font-size: 20px;
        color: rgba(236, 248, 255, 0.9);
        transition: all 0.3s ease;

        .cell-product {
          font-weight: 500;
          color: #ecf8ff;
          text-shadow: 0 0 8px rgba(236, 248, 255, 0.3);
        }

        .cell-origin {
          color: rgba(236, 248, 255, 0.7);
          font-size: 18px;
        }

        .cell-price {
          font-family: 'DIN Alternate', 'Helvetica Neue', monospace;
          font-weight: 600;
          font-size: 20px;

          &.high {
            color: #ff6b6b;
            text-shadow: 0 0 10px rgba(255, 107, 107, 0.4);
            animation: price-glow-red 2s ease-in-out infinite;
          }

          &.low {
            color: #12c76a;
            text-shadow: 0 0 10px rgba(18, 199, 106, 0.4);
            animation: price-glow-green 2s ease-in-out infinite;
            animation-delay: 0.5s;
          }

          &.avg {
            color: #f59e0b;
            text-shadow: 0 0 10px rgba(245, 158, 11, 0.4);
          }
        }

        @keyframes price-glow-red {
          0%,
          100% {
            text-shadow: 0 0 10px rgba(255, 107, 107, 0.4);
          }
          50% {
            text-shadow: 0 0 20px rgba(255, 107, 107, 0.7);
          }
        }

        @keyframes price-glow-green {
          0%,
          100% {
            text-shadow: 0 0 10px rgba(18, 199, 106, 0.4);
          }
          50% {
            text-shadow: 0 0 20px rgba(18, 199, 106, 0.7);
          }
        }
      }

      &:nth-child(odd) {
        background: rgba(12, 24, 52, 0.6);
      }

      &:nth-child(even) {
        background: rgba(20, 36, 76, 0.8);
      }
    }
  }
}
</style>
